import {TranslateService} from '@ngx-translate/core';
import {type SmContextMenuItemModel} from '../shared/components/sm-context-menu-item/sm-context-menu-item.component';

export const CONTAINER_ITEM_MENU_ARIA_LABEL_KEY = 'contextMenu.itemAriaLabel';

export const CONTAINER_ITEM_MENU_ITEMS: SmContextMenuItemModel[] = [
  {id: 'add-to-basket', textKey: 'contextMenu.itemActions.addToBasket', iconName: 'basket-outline'},
  {id: 'clone', textKey: 'contextMenu.itemActions.clone', iconName: 'copy-outline'},
  {id: 'edit', textKey: 'contextMenu.itemActions.edit', iconName: 'pencil-outline'},
  {id: 'move', textKey: 'contextMenu.itemActions.move', iconName: 'inventory-move'},
  {id: 'write-off', textKey: 'contextMenu.itemActions.writeOff', iconName: 'remove-circle-outline'},
  {id: 'delete', textKey: 'contextMenu.itemActions.delete', iconName: 'trash-outline'},
];

export function buildContainerItemMenuAriaLabel(
  translateService: TranslateService,
  name: string,
): string {
  return translateService.instant(CONTAINER_ITEM_MENU_ARIA_LABEL_KEY, {name});
}
